import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, MapPin, Trophy } from "lucide-react";

interface LocalSEOHubHeroProps {
  language: 'es' | 'en';
}

export const LocalSEOHubHero = ({ language }: LocalSEOHubHeroProps) => {
  const content = {
    es: {
      badge: "SEO Local para negocios B2B",
      title: "SEO Local para empresas que necesitan clientes en su ciudad",
      subtitle: "Si tu negocio depende de clientes locales, necesitas aparecer cuando buscan tus servicios. El SEO local posiciona tu empresa en Google Maps y búsquedas de tu zona.",
      cta: "Solicitar reunión inicial gratuita de 30 minutos",
      ctaSecondary: "Ver casos locales",
      ctaNote: "30 minutos · Sin compromiso",
      diagnosticLink: "/diagnostico-seo-gratis",
      casesLink: "/casos-de-exito"
    },
    en: {
      badge: "Local SEO for B2B businesses",
      title: "Local SEO for companies that need clients in their city",
      subtitle: "If your business depends on local clients, you need to appear when they search for your services. Local SEO positions your company in Google Maps and local searches.",
      cta: "Request free 30-minute initial consultation",
      ctaSecondary: "View local cases",
      ctaNote: "30 minutes · No commitment",
      diagnosticLink: "/en/free-seo-diagnosis",
      casesLink: "/en/case-studies"
    }
  };

  const t = content[language];

  return (
    <section className="section-padding bg-background">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand/10 rounded-full text-brand text-sm font-medium mb-8">
            <MapPin className="w-4 h-4" />
            {t.badge}
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            {t.title}
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4">
            <Button 
              size="lg" 
              className="btn-gradient group text-base px-8 py-6"
              asChild
            >
              <Link to={t.diagnosticLink}>
                <Calendar className="mr-2 h-5 w-5" />
                {t.cta}
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
            
            <Button 
              size="lg" 
              variant="outline"
              className="group text-base px-8 py-6"
              asChild
            >
              <Link to={t.casesLink}>
                <Trophy className="mr-2 h-5 w-5" />
                {t.ctaSecondary}
              </Link>
            </Button>
          </div>
          
          <p className="text-sm text-muted-foreground">
            {t.ctaNote}
          </p>
        </div>
      </div>
    </section>
  );
};
